import React, {useContext, useEffect, useRef, useState} from "react";
import {CategoryComponentInterface, CategoryState} from "./interfaces/CategoryState";
import CategoryController from "./controller/CategoryController";
import {MarketContext} from "../Main/context/MarketContext";
import MarketRepository from "../Main/repository/MarketRepository";
import BuyToolbar from "../Home/view/component/BuyToolbar/BuyToolbar";
import CustomOrder from "../customOrder/customOrder";
import {useParams, useSearchParams} from "react-router-dom";
import CategoryError from "./CategoryError";
import {useTranslation} from "react-i18next";

export default function Category() {
    const {t} = useTranslation();
    const context = useContext(MarketContext)
    const card = MarketRepository.getCartMarket();
    const [searchParams] = useSearchParams()
    const {shopId} = useParams()
    const shopIdGet = searchParams.get("id")
    const checkShopId = (shopId || shopIdGet) as string
    const [state, setState] = useState<CategoryComponentInterface>({
        loading: false,
        categories: [],
        error: false,
        activeCategory: 'all',
    })
    const controller = useRef(new CategoryController(state, setState));

    useEffect(() => {
        controller.current.getCategories(checkShopId).then()
    }, []);

    if (state.loading)
        return null;

    if (state.error)
        return <CategoryError productController={controller.current}/>

    return (
        <>
            <BuyToolbar/>
            <nav className={`category-container ${card.items.length ? 'active-buy-toolbar' : ''}`}>
                <ul>
                    <li onClick={() => new CategoryController(state, setState).setSelectedCategory('all', context)}
                        className={`${context.state.categoryActive === 'all' ? "active-category" : ""}`}>
                        <span>{t("all")}</span>
                    </li>
                    {state.categories.map((item: CategoryState) => (
                        <li key={item._id}
                            onClick={() => new CategoryController(state, setState).setSelectedCategory(item._id, context)}
                            className={`${item._id === context.state.categoryActive ? "active-category" : ""}`}>
                            <span>{item.name}</span>
                        </li>
                    ))}
                </ul>
                <CustomOrder/>
            </nav>
        </>
    )
}
